import script from "./my-menu2.vue?vue&type=script&setup=true&lang=js"
export * from "./my-menu2.vue?vue&type=script&setup=true&lang=js"

import "./my-menu2.vue?vue&type=style&index=0&id=0c79edcd&lang=css"
import "./my-menu2.vue?vue&type=style&index=1&id=0c79edcd&lang=scss&scoped=true"

import exportComponent from "/usr/local/jenkins/workspace/pc-web_pc-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c79edcd"]])

export default __exports__